import { useUserStore } from '~/stores/user'
import { MFANotSetupException, MFARequiredException } from '~/types/exceptions'

export default defineNuxtRouteMiddleware(async () => {
  const user = useUserStore()
  try {
    if (!await user.isAuthenticated()) {
      user.logout()
      return navigateTo('/auth/login')
    }
  } catch (error) {
    if (error instanceof MFARequiredException) {
      return navigateTo('/auth/totp/verify')
    }

    if (error instanceof MFANotSetupException) {
      return navigateTo('/auth/totp/setup')
    }

    throw error
  }
})
